import {
    InventoryLocationInteractionMode
} from "./interaction";
import {
    drawInventoryLocationStyle,
    inventoryLocationThermalImagingRoutesStyle
} from "../../../../map/styles/inventory-locations";
import {Collection} from "ol";
import * as turf from "@turf/turf";
import {getLength} from "ol/sphere";
import * as $ from "jquery";
import {InventoryLocationInteractionMulti} from "./interaction-multi";
import {EpInventoryLocationRoutes} from "../../../../map/layers/inventory-location-routes";

export class InventoryLocationInteractionThermalImagingRoutes extends InventoryLocationInteractionMulti {
    /**
     * @param {InventoryLocationInteractionsHandler} handler
     */
    constructor(handler) {
        const layer = new EpInventoryLocationRoutes(handler.epMap.map);

        handler.epMap.addCustomLayer(layer)

        super('thermal_imaging_routes', handler, layer);

        this.dictionary = {
            [InventoryLocationInteractionMode.DRAW]: 'Dodaj trasę',
            deleteConfirm: 'Czy na pewno chcesz usunąć wybraną trasę?',
            measurementTitle: 'Długość',
            measurementUnit: 'm'
        };

        this.customCreateFeatureFromInput('LineString', inventoryLocationThermalImagingRoutesStyle, 'Trasa');
        this.updateLengthInfo();
    }

    draw() {
        super.draw();
        let that = this;

        this.handler.epMap.helpTooltip.set('Aby zakończyć rysowanie trasy, kliknij drugi raz w miejsce ostatniego punktu');

        this.addOlInteraction(
            this.epLayer.addDraw({
                noSource: true,
                style: drawInventoryLocationStyle,
                type: 'LineString',
                condition: (e) => {
                    let features = this.handler.epMap.getOlMap().getFeaturesAtPixel(e.pixel, {
                        layerFilter: (layer) => {
                            return layer === this.handler.epMap.boundaries.getLayer();
                        }
                    });
                    return features.length > 0;
                },
                end: function (e) {
                    let feature = that.addFeature(e.feature);
                    that.handler.setCurrentInteraction(null);

                    that.addToList(feature, 'Trasa #' + that.features.length);
                    that.updateLengthInfo();

                    e.feature.setStyle(inventoryLocationThermalImagingRoutesStyle)
                }
            })
        )
    }

    edit() {
        super.edit();

        let that = this;
        let feature = this.features.find(feature => feature.get('id') === this.currentId);
        let previousCoordinates = feature.getGeometry().getCoordinates();

        this.addOlInteraction(
            this.epLayer.addEdit({
                style: drawInventoryLocationStyle,
                features: new Collection(this.features),
                end: function (e) {
                    let feature = e.features.item(0);

                    if (
                        !turf.booleanWithin(
                            turf.lineString(feature.getGeometry().getCoordinates()),
                            that.handler.epMap.boundaries.getBufferedBoundariesPolygon(2)
                        )
                    ) {
                        feature.getGeometry().setCoordinates(previousCoordinates);
                        return;
                    }

                    that.updateFeature(feature);
                    previousCoordinates = feature.getGeometry().getCoordinates();

                    that.updateLengthInfo();
                }
            })
        )
    }

    end(forced) {
        super.end(forced);
        this.updateLengthInfo();
    }

    updateLengthInfo() {
        let summaryLength = 0;

        for(let feature of this.features) {
            let length = getLength(feature.getGeometry());
            summaryLength += length;
            $(`[data-app-map_interaction_area="${this.name}"][data-app-feature_id="${feature.get('id')}"]`).text(length.toFixed(2))
        }

        $('[data-app-information_name="routes_length"] [data-app-information_value]').text(summaryLength.toFixed(2))
    }
}